<template>
  <header class="beast-main-header">
    <div class="container">
      <div class="row">
        <div class="col-3 align-middle">
          <router-link to="/">
            <div class="beast-logo">
              beast repository
            </div>
          </router-link>
        </div>
        <div class="offset-6 col-3 align-middle text-right beast-user-menu" v-if="isLoggedIn">
          Welcome, <router-link :to="`/profile/${me.username}`">{{me.username}}</router-link>!<br/>
          <a href="javascript:void(0);" v-on:click="logout()">
            Logout
          </a>
        </div>
        <div class="offset-6 col-3 align-middle text-right beast-user-menu" v-else>
          <router-link to="/auth/login">log in</router-link>
          or
          <router-link to="/auth/signup">sign up</router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "BeastHeader",
  computed: {
    isLoggedIn() {
      return this.$auth.check() && this.me !== undefined && this.me !== null;
    },
  },
  data() {
    return {
      me: {
        username: ""
      }
    };
  },
  methods: {
    logout() {
      this.$router.replace("/auth/logout");
    }
  },
  async beforeMount() {
    await this.$auth.ready();
    this.me = JSON.parse(sessionStorage.getItem("user"));
  }
};
</script>

<style scoped lang="scss">
  .beast-logo {
    vertical-align: middle;
    display: block;
    width: 265px;
    height: 100px;
    text-align: center;
    text-indent: -5000px;
    background: transparent url("../../assets/beast_logo.png") no-repeat center center;
    background-size: contain;
  }

  .beast-user-menu {
    vertical-align: middle;
    margin-top: 25px;

    a {
      font-weight: bold;
    }
  }
</style>
